import updateRecurrenceOnStartDateChange from 'owa-recurrence-utils/lib/updateRecurrenceOnStartDateChange';
import type { DisplayDate } from 'owa-datetime';
import type { FullComposeViewState } from 'owa-calendar-compose-types';
import { orchestrator } from 'satcheljs';
import {
    updateCustomRecurrenceFormRecurrenceType,
    updateCustomRecurrenceFormStartDate,
} from 'owa-calendar-compose-form-actions';
import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';

export default orchestrator(
    updateCustomRecurrenceFormStartDate,
    (actionMessage: { startDate: DisplayDate; formId: string }) => {
        const fullComposeViewState: FullComposeViewState = getFullComposeViewState(
            actionMessage.formId
        );

        if (!fullComposeViewState) {
            return;
        }

        const { recurrence } = fullComposeViewState.customRecurrenceViewState;

        if (recurrence) {
            const newStartDate = actionMessage.startDate;
            updateCustomRecurrenceFormRecurrenceType(
                updateRecurrenceOnStartDateChange(newStartDate, recurrence),
                actionMessage.formId
            );
        }
    }
);
